  <template>
  <!-- Display messages driver chat -->
  <div class="driver-chat-container">
    <div class="chat-content">
      <div class="driver-info">
        <div class="driver-card">
          <div class="driver-header">
            <md-icon icon="person" class="driver-icon"/>
            <h4 class="driver-title">Información del Conductor</h4>
          </div>
          <div v-if="driver == null" class="no-driver">
            <md-icon icon="info" class="info-icon"/>
            <p>Sin datos disponibles del conductor</p>
          </div>
          <div v-if="driver != null" class="driver-details">
            <div class="detail-item">
              <span class="detail-label">Nombre:</span>
              <span class="detail-value">{{ driver.firstName }} {{ driver.lastName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Teléfono:</span>
              <span class="detail-value">{{ driver.phone }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Email:</span>
              <span class="detail-value">{{ driver.email }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="messages-container">
        <div class="chat-header">
          <h3 class="chat-title">Chat del Viaje</h3>
          <div class="chat-controls">
            <b-form-checkbox
              v-model="localTime"
              value="accepted"
              class="time-checkbox"
              @change="changeToLocaltimeZone($event)"
            >
              Ver en hora local
            </b-form-checkbox>
            <b-button 
              variant="outline-light" 
              class="refresh-btn" 
              v-b-tooltip.hover 
              title="Recargar chat"
              @click="reloadConversation"
            >
              <md-icon icon="update"/>
            </b-button>
          </div>
        </div>
        <div class="chat chat-container">
          <div class="chat-messages">
            <!-- Contenedor de mensajes -->
            <div class="chat__messages" aria-live="polite" v-if="loading == false">
              <!-- Componente de mensaje receptor -->
              <article
                v-for="(message, index) in messages"
                :key="index"
                :class="['message', 'message--'+message.userType]">
                  <div class="message-header">
                    <span class="message__username">
                      <md-icon 
                        :icon="message.userType === 'client' ? 'person' : 'local_shipping'" 
                        class="user-icon"
                      />
                      {{ message.userType === 'client' ? 'Cliente' : 'Conductor'}}
                    </span>
                  </div>
                  <div class="message-content">
                    <p class="message__text">{{ message.content }}</p>
                    <div class="message__datetime">
                      <md-icon v-if="message.seen" icon="done_all" class="seen-icon"/>
                      <span class="time-text">{{ message.dateTimeString }}</span>
                    </div>
                  </div>
              </article>
            </div>

            <div class="empty-chat" v-if="messages.length == 0 && loading == false">
              <md-icon icon="chat_bubble_outline" class="empty-icon"/>
              <p>Chat no disponible</p>
            </div>
            
            <!-- Loading -->
            <div v-if="loading" class="loading-container">
              <div class="loading-spinner">
                <b-spinner variant="primary" class="spinner-item"></b-spinner>
              </div>
              <p class="loading-text">Cargando conversación...</p>
            </div>
            <!-- End Loading -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "../../../../api.js";
var moment = require('moment-timezone');

export default {
  name: 'Chat',
  props: {
    transportServiceId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      messages: [],
      driver: null,
      localTime: false,
      timeZoneName: null,
      loading: false
    }
  },
  methods: {
    getConversation() {
      this.loading = true
      api(this)
				.get("/transport-services/driver/chat/" + this.transportServiceId)
				.then(res => {
          this.timeZoneName = res.data.timezone
					this.messages     = this.processMessages(res.data.messages)
          this.driver       = res.data.driver
				})
				.finally(() => {
          this.loading = false;
				});
    },
    parseDate(date) {

      var datetime = new Date(0)
      datetime.setUTCSeconds(date._seconds)
      if (this.localTime == false && this.timeZoneName != null) {
        datetime = datetime.toLocaleString('en-US', {timeZone: this.timeZoneName})
      }
      let dateStr = moment.parseZone(datetime);

      return dateStr
    },
    formatDateTime(date) {
      return date.format("DD/MMMM/YYYY HH:mm");
    },
    processMessages(messages) {
      let messagesConversation = []
      messages.forEach(message => {
        let dateTime = this.parseDate(message.createdAt)
        message      = { ...message, ...{
          dateTime: dateTime, 
          dateTimeString: this.formatDateTime(dateTime)
        }}
        messagesConversation.push(message)
      })

      messagesConversation.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.dateTime) - new Date(b.dateTime);
      })

      return messagesConversation
    },
    reloadConversation() {
      // Reload conversation
      this.getConversation()
    },
    changeToLocaltimeZone() {
      this.messages = this.processMessages(this.messages)
    }
  },
  mounted() {
    this.getConversation()
  },
}
</script>

<style scoped>
/* Driver Chat Container */
.driver-chat-container {
  background: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Chat Header */
.chat-header {
  background: linear-gradient(135deg, #4f39cf 0%, #6366f1 100%);
  color: white;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.chat-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.time-checkbox {
  color: white;
}

.time-checkbox .custom-control-label {
  color: white;
  font-size: 0.9rem;
}

.refresh-btn {
  border: 2px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.refresh-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

/* Chat Content */
.chat-content {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 1rem;
  padding: 1rem;
  min-height: 500px;
}

/* Driver Info */
.driver-info {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: fit-content;
}

.driver-card {
  padding: 1.5rem;
}

.driver-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.driver-icon {
  color: #4f39cf;
  font-size: 1.5rem;
}

.driver-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
}

.no-driver {
  text-align: center;
  padding: 2rem 0;
  color: #6c757d;
}

.info-icon {
  font-size: 2rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.driver-details {
  space-y: 1rem;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f1f3f4;
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 600;
  color: #4a5568;
  font-size: 0.9rem;
}

.detail-value {
  color: #2d3748;
  font-size: 0.9rem;
  word-break: break-word;
  text-align: right;
}

/* Messages Container */
.messages-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chat-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  max-height: 450px;
}

/* Chat Messages */
.chat__messages {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  min-height: 400px;
}

/* Messages */
.message {
  max-width: 70%;
  margin-bottom: 1.5rem;
  position: relative;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message--client {
  margin-left: auto;
}

.message--driver {
  margin-right: auto;
}

.message-header {
  margin-bottom: 0.5rem;
}

.message__username {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0;
}

.user-icon {
  font-size: 1rem;
}

.message--client .message__username {
  color: #4f39cf;
  justify-content: flex-end;
}

.message--driver .message__username {
  color: #059669;
}

.message-content {
  background: white;
  border-radius: 16px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}

.message--client .message-content {
  background: #4f39cf;
  color: white;
}

.message--driver .message-content {
  background: #10b981;
  color: white;
}

.message__text {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
  word-wrap: break-word;
}

.message__datetime {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.75rem;
  font-size: 0.75rem;
  opacity: 0.8;
}

.message--client .message__datetime {
  justify-content: flex-end;
}

.seen-icon {
  font-size: 0.9rem;
  color: #22c55e;
}

.time-text {
  white-space: nowrap;
}

/* Empty Chat */
.empty-chat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #6b7280;
  text-align: center;
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #d1d5db;
}

/* Loading */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
}

.loading-spinner {
  margin-bottom: 1rem;
}

.spinner-item {
  width: 2rem;
  height: 2rem;
}

.loading-text {
  color: #6b7280;
  font-size: 0.9rem;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .chat-content {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .driver-info {
    order: 2;
  }
  
  .messages-container {
    order: 1;
  }
  
  .message {
    max-width: 85%;
  }
}

@media (max-width: 480px) {
  .chat-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
  
  .chat-controls {
    width: 100%;
    justify-content: space-between;
  }
  
  .detail-value {
    max-width: 120px;
  }
}

</style>